import React from 'react'
import Lottie from 'react-lottie'
import { Box, Typography, Backdrop } from '@kyc-ui/react'
import useTheme from 'src/hooks/common/useTheme'

interface Props {
  height?: number | string
  width?: number | string
  hide?: boolean
  isGlobal?: boolean
  message?: string
}

const Loading: React.FC<Props> = (props) => {
  const { hide = false, isGlobal = false, height = 64, width = 64, message = '' } = props
  const theme = useTheme()
  const loadingBox = () => (
    <Box sx={{ backgroundColor: 'white', borderRadius: '16px' }}>
      {theme.lotties?.loading && (
        <Lottie
          height={height}
          options={{
            autoplay: true,
            animationData: JSON.parse(theme.lotties.loading),
            loop: true,
            rendererSettings: {
              preserveAspectRatio: 'xMidYMid slice'
            }
          }}
          width={width}
        />
      )}
    </Box>
  )

  return isGlobal ? (
    <Backdrop
      open={!hide}
      style={{ flexDirection: 'column', backdropFilter: 'blur(3px)', zIndex: 9999 }}
      data-testid="loading-backdrop"
    >
      <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', gap: 2 }}>
        {loadingBox()}
        {message && <Typography color={theme.palette.common.white}>{message}</Typography>}
      </Box>
    </Backdrop>
  ) : hide ? (
    <></>
  ) : (
    loadingBox()
  )
}

export default Loading
